import React, { useState, useRef } from "react";
import "./collapsible.scss"; // Import the CSS file for styling

interface CollapsibleProps {
    title: string;
    children: React.ReactNode;
    isOpen?: boolean;
    onToggle?: (isOpen: boolean) => void;
}

const Collapsible: React.FC<CollapsibleProps> = ({ title, children, isOpen: controlledIsOpen, onToggle }) => {
    const [internalIsOpen, setInternalIsOpen] = useState(false);
    const isOpen = controlledIsOpen !== undefined ? controlledIsOpen : internalIsOpen;
    const contentRef = useRef<HTMLDivElement>(null);

    const toggleCollapse = () => {
        const newIsOpen = !isOpen;
        if (controlledIsOpen === undefined) {
            setInternalIsOpen(newIsOpen);
        }
        onToggle?.(newIsOpen);
    };

    return (
        <div className="collapsible">
            <button className="collapsible-header" onClick={toggleCollapse}>
                {title}
                <span className={`arrow ${isOpen ? "open" : ""}`}>▼</span>
            </button>
            {isOpen &&
                <div
                    className="collapsible-content"
                    style={{
                        maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : "0px",
                    }}
                    ref={contentRef}
                >
                    {children}
                </div>
            }
        </div>
    );
};

export default Collapsible;